import React, { forwardRef } from 'react';
import { useComponentDefaultProps } from '@mantine/styles';
import { useMenuContext } from '../Menu.context.js';
import useStyles from './MenuDivider.styles.js';
import { Box } from '../../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __getOwnPropSymbols(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return target;
};

var defaultProps = {};
var MenuDivider = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("MenuDivider", defaultProps, props),
      children = _a.children,
      className = _a.className,
      others = __objRest(_a, ["children", "className"]);

  var _useMenuContext = useMenuContext(),
      classNames = _useMenuContext.classNames,
      styles = _useMenuContext.styles,
      unstyled = _useMenuContext.unstyled,
      variant = _useMenuContext.variant;

  var _useStyles = useStyles(null, {
    name: "Menu",
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    variant: variant
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      className: cx(classes.divider, className),
      ref: ref
    }, others))
  );
});
MenuDivider.displayName = "@mantine/core/MenuDivider";
export { MenuDivider };